import yup from 'src/libraries/validator.library';

const SensitiveCitiesShape = {
  sensitiveCity: yup.string().required(),
  pamLead: yup.string().nullable(),
};

export const SensitiveCitiesSchema = yup
  .object()
  .shape({
    sensitiveCityId: yup.number(),
    ...SensitiveCitiesShape,
  })
  .defined();

export const SensitiveCitiesListSchema = yup
  .object({
    sensitiveCities: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                sensitiveCityId: yup.number(),
                ...SensitiveCitiesShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const SensitiveCitiesFormSchema = yup
  .object()
  .shape({
    ...SensitiveCitiesShape,
  })
  .defined();

export type ISensitiveCities = yup.InferType<typeof SensitiveCitiesSchema>;
export type ISensitiveCitiesRow = yup.InferType<typeof SensitiveCitiesListSchema>;
export type ISensitiveCitiesForm = yup.InferType<typeof SensitiveCitiesFormSchema>;
